<template>
  <div class="custom-menu">
    <el-menu
      mode="horizontal"
      text-color="#fff"
      active-text-color="#00AAFF"
      v-if="pMenuList.length"
      :router="false"
      :default-active="defaultActive"
      @select="selectHandler"
    >
      <!-- 这里先将一级菜单生成，防止调用递归子菜单时多一个根div，影响样式 -->
      <template v-for="(value, index) in this.pMenuList">
        <el-submenu

          :index="value.Url == '#' || !value.Url ? '#' + value.ID : value.Url"
          @click="toLink(value.Url, value.Target)"
          v-if="hasChild(value.ID)"
          :key="value.ID"
          :popper-append-to-body="false"
        >
          <template slot="title">
            <i :class="value.Icon"></i>
            {{ value.Name }}
          </template>
          <MyMenu  :pID="value.ID"></MyMenu>
        </el-submenu>
        <el-menu-item
          :index="value.Url == '#' || !value.Url ? '#' + value.ID : value.Url"
          @click="toLink(value.Url, value.Target)"
          v-else-if="value.ID!='1'"
          :key="value.ID"
        >
          <i :class="value.Icon"></i>
         <span class="font-size"> {{ value.Name }}</span>
        </el-menu-item>
      </template>
    </el-menu>
  </div>
</template>

<script>
import MyMenu from "./Menu"; //引入子菜单组件
import { menuRouteMixin } from "../../mixins/menuRoute";
import menuRedirect from "../../router/menuRedirect";
export default {
  name: "HorizontalMenu",
  mixins: [menuRouteMixin],
  props: {
    rootID: {
      type: [Number, String],
      default: 0,
    },
  },
  components: {
    //子菜单递归组件
    MyMenu,
  },
  data() {
    return {
      //存储所有菜单的项
      menuList: this.$store.state.menuData,
      //存储一级菜单的项
      pMenuList: [],
      defaultActive: "background: ",
      tempMenu: [],
      defaultOpeneds: [],
    };
  },
  created() {
    this.menuList = this.$store.state.menuData;
    for (let i = 0; i < this.menuList.length; i++) {
      if (this.menuList[i].Url == "#" || !this.menuList[i].Url)
        this.menuList[i].Url = "#" + this.menuList[i].ID;
    }

    let match = window.sessionStorage.getItem("curMenu");
    this.setLeftMenuInfo(match);
    this.getMenu();
  },
  methods: {
    //获取菜单数据
    getMenu() {
      var that = this;
      that.pMenuList = that.menuList.filter(function (m) {
        return m.ParentID == that.rootID; //一级菜单父id为"0"
      });
    },
    //判断是否还有子菜单
    hasChild(id) {
      let that = this;
      let curMenu = that.menuList.filter(function (m) {
        return m.ID == id;
      });
      let tempMenuList = that.menuList.filter(function (m) {
        return m.ParentID == id;
      });
      if (tempMenuList.length > 0 && curMenu[0].IsDropDown != "0") {
        return true;
      }
      return false;
    },
    //切换菜单时判断IsDropDown是否为1，1：代表子菜单下拉表示，0：代表子菜单用左侧菜单来展示
    selectHandler(index, indexPath) {
      this.setLeftMenuInfo(index);
      this.$store.commit("setCurMenu", index);
      //this.$store.commit("saveCurLeftMenu", index);
    },
    setLeftMenuInfo(path) {
      let menuObj = this.menuList.filter((item) => {
          return item.Url == path && item.IsDropDown == '0';
      });
      //重新赋值
      this.$store.state.defaultOpeneds = [];
      this.defaultOpeneds = [];
        if (menuObj.length > 0 && menuObj[0].IsDropDown != "1") {
        if (path.startsWith("#")) this.getmenuObj(menuObj[0]);
        else {
          menuRedirect.redirect(this, menuObj[0].Url);
          this.defaultOpeneds.push("#" + menuObj[0].ParentID);
        }
        this.$store.commit("saveLeftMenuPID", menuObj[0].ID);
        this.$store.commit("saveDefaultOpeneds", this.defaultOpeneds);
      } else {
        this.$store.commit("saveLeftMenuVisible", false);
      }
    },
    //循环获取有地址的菜单
    getmenuObj(obj) {
      let menuObj = this.menuList.filter((item) => {
        return item.ParentID == obj.ID;
      });
      if (!menuObj[0].Url.startsWith("#")) {
        menuRedirect.redirect(this, menuObj[0].Url);
        this.defaultOpeneds.push("#" + menuObj[0].ParentID);
      } else menuObj = this.getmenuObj(menuObj[0]);
    },
  },
  mounted() {
    this.$nextTick(() => {
      //页面刷新后重新将当前选中的菜单置为选中项,这里设置curMenu的值依赖面包屑组件
      let match = window.sessionStorage.getItem("curMenu");
      this.defaultActive = match;
    });
  },
  watch: {
    "$store.state.curMenu": function (newValue, oldValue) {
      this.defaultActive = newValue;
    },
  },
  computed: {},
};
</script>

<style lang="less" scoped>
.font-size{
  font-size: 20px !important;
}
/deep/.el-submenu__icon-arrow {
    font-size: 14px !important;
}

 /deep/.el-submenu [class^="el-icon-"] {
   margin-right: -2px;
 }

 /deep/.el-menu--horizontal > .el-submenu .el-submenu__icon-arrow {
   margin-left: 0px !important;
 }
</style>
<style>

</style>
